import {
  ChangePassworResponse,
  ChangePasswordData,
  ForgotPasswordData,
  ForgotPasswordResponse,
  LoginCredentials,
  LoginResponse,
  LogoutAllDeviceResponse,
  LogoutResponse,
  RegisterData,
  RegisterResponse,
  ResendOtpResponse,
  ResetPasswordData,
  ResetPasswordResponse,
  User,
  VerifyEmailOtpData,
  VerifyEmailOtpResponse,
  VerifyPasswordResetOtpData,
  VerifyPasswordResetOtpResponse,
} from "../types/auth.type";
import { apiClient } from "./client";

export const authApi = {
  register: (data: RegisterData) =>
    apiClient.post<RegisterResponse>("/auth/register", data),

  verifyEmailOtp: (data: VerifyEmailOtpData) =>
    apiClient.post<VerifyEmailOtpResponse>("/auth/verify-email-otp", data),

  resendEmailOtp: (email: string) =>
    apiClient.post<ResendOtpResponse>("/auth/resend-email-otp", { email }),

  login: (credentials: LoginCredentials) =>
    apiClient.post<LoginResponse>("/auth/login", credentials),

  getCurrentUser: () =>
    apiClient.get<{ success: boolean; data: User }>("/users/profile"),

  logout: () => apiClient.post<LogoutResponse>("/auth/logout"),

  logOutAllDevice: (user_id: string) =>
    apiClient.post<LogoutAllDeviceResponse>("/auth/logout-all-devices", {
      user_id,
    }),

  forgotPassword: (data: ForgotPasswordData) =>
    apiClient.post<ForgotPasswordResponse>("/auth/forgot-password", data),

  verifyPasswordResetOtp: (data: VerifyPasswordResetOtpData) =>
    apiClient.post<VerifyPasswordResetOtpResponse>(
      "/auth/verify-password-reset-otp",
      data
    ),

  resetPassword: (data: ResetPasswordData) =>
    apiClient.post<ResetPasswordResponse>("/auth/reset-password", data),

  changePassword: (data: ChangePasswordData) =>
    apiClient.put<ChangePassworResponse>("/users/change-password", data),
};
